const initialState={
    toggleAdmin: false
}

const reducer = (state = initialState, action) => {
    if (action.type === 'CHANGEMODE') {
        if(state.toggleAdmin===false){
            return {
                toggleAdmin: true
            }
        }
        else{
            return {
                toggleAdmin: false
            }
        }
      
    }
    return state;
}

export default reducer;